import React from 'react'
import { Spinner } from 'lib/ui/components'
import { useProductSelector } from 'hooks/productSelector'
import { ProductSelectorQuestions, ProductSelectorModal } from 'components/ProductSelector'
import { PRODUCT_SELECTOR_CODE } from 'app/livbrite/resources/constants'
import { HeaderWrapper, NoQuestions } from './components/Styled'
import { Header } from './components/Header'

export const Questions = () => {
  const {
    loading,
    questionData,
    resultsReady,
    step,
    setStep,
    submitAnswer,
    stepBack,
    setShowResults,
    questions,
    saveCustomerAnswers,
    savingAnswer,
    noQuestions,
    setCustomerEmail
  } = useProductSelector({
    questionnaireCode: PRODUCT_SELECTOR_CODE.SELECTOR
  })

  const { title, options, id: questionId, type } = questionData ?? {}
  const isReviewStep = resultsReady
  const handleSubmit = (values: Record<string, any>) => {
    submitAnswer(values)
  }
  const isFirstStep = step === 0

  return (
    <>
      <div>
        {savingAnswer && (
          <Spinner />
        )}
        <HeaderWrapper>
          <Header />
        </HeaderWrapper>
        {noQuestions ? (
          <NoQuestions>
            Sorry, we couldn't find questions.
            <br />
            Please, try again later
          </NoQuestions>
        ) : (
          <ProductSelectorQuestions
            loading={loading}
            title={title}
            type={type}
            options={options}
            handleSubmit={handleSubmit}
            isReviewStep={isReviewStep}
            questionId={questionId}
            isFirstStep={isFirstStep}
            setStep={setStep}
            stepBack={stepBack}
            step={step}
            setShowResults={setShowResults}
            questions={questions}
            saveCustomerAnswers={saveCustomerAnswers}
          />
        )}
      </div>
      <ProductSelectorModal
        setCustomerEmail={setCustomerEmail}
      />
    </>
  )
}
